import fetch from "isomorphic-unfetch"

export const CALL_API = "@@redux-api-middleware/callApi"

const handleRequest = (request, action, store) => {
	if (typeof request === "object") {
		dispatch({
			type: request.type,
			payload: request.payload(action, store.getState()),
		})
	} else {
		store.dispatch({ type: request })
	}
}

const handleSuccess = (success, action, store, res, previewUrl = null) => {
	if (typeof success === "object") {
		store.dispatch({
			type: success.type,
			payload: success.payload(action, store.getState(), res),
		})
	} else {
		return res.json().then(payload => store.dispatch({ type: success, payload, statusCode: res.status, previewUrl }))
	}
}

const handleFailure = (failure, action, store, err) => {
	if (typeof failure === "object") {
		store.dispatch({
			type: failure.type,
			payload: failure.payload(action, store.getState()),
		})
	} else {
		store.dispatch({ type: failure })
	}
}

export default store => next => action => {
	if (typeof action === "object" && action[CALL_API]) {
		const {
			endpoint,
			previewUrl,
			method = "GET",
			body,
			types: [request, success, failure],
		} = action[CALL_API]

		handleRequest(request, action, store)

		const fetchApi = ["GET", "HEAD"].includes(method)
			? fetch(endpoint, { method })
			: fetch(endpoint, {
					method,
					headers: { "Content-Type": "application/json" },
					body: JSON.stringify(body),
			  })

		return fetchApi
			.then(res => handleSuccess(success, action, store, res, previewUrl))
			.catch(err => {
				handleFailure(failure, action, store, err)
			})
	} else {
		return next(action)
	}
}
